import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import { NavLink } from "react-router-dom";
import { dLogout } from "../http";
import { setAuth } from "../store/auth-slice";
import { fetchNotices, fetchInternNotices } from "../http"; // API call for fetching notices


const Navigation = () => {
  const {
    name,
    image: profile,
    type,
  } = useSelector((state) => state.authSlice.user);
  const dispatch = useDispatch();
  const history = useHistory();
  const { user } = useSelector((state) => state.authSlice);

  const [notices, setNotices] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [unreadCount, setUnreadCount] = useState(0);

  useEffect(() => {
    loadNotices();
    // eslint-disable-next-line
  }, []);

  const styles = {
    scrollableDropdown: {
      maxHeight: "300px",
      overflowY: "auto",
    },
    notificationDot: {
      position: "absolute",
      top: "10px",
      right: "12px",
      width: "10px",
      height: "10px",
      backgroundColor: "red",
      borderRadius: "50%",
    },
    unreadNotice: {
      fontWeight: "bold",
      backgroundColor: "#f8f9fa",
    },
  };

  const loadNotices = async () => {
    setIsLoading(true);
    try {
      let response;
      if (user.type === "Intern") {
        response = await fetchInternNotices();
      } else {
        response = await fetchNotices();
      }
      const noticeData = response.data;
      setNotices(noticeData);
      setUnreadCount(noticeData.filter((notice) => !notice.read).length);
    } catch (error) {
      console.error("Error fetching notices:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const markAllAsRead = async () => {
    try {
      // Update state to mark all notices as read
      const updatedNotices = notices.map((notice) => ({
        ...notice,
        read: true,
      }));
      setNotices(updatedNotices);
      setUnreadCount(0); // Reset unread count to remove notification dot

      // Optionally, persist read status in backend
      await fetchNotices({ markAsRead: true });
    } catch (error) {
      console.error("Error marking notices as read:", error);
    }
  };

  const logout = async () => {
    await dLogout();
    dispatch(setAuth(null));
    history.push("/login");
  };

  const handleClick = (e) => {
    e.preventDefault();
  };

  return (
    <>
      <div className="navbar-bg"></div>
      <nav className="navbar navbar-expand-lg main-navbar">
        <form className="form-inline mr-auto">
          <ul className="navbar-nav mr-3 d-lg-none w-100 d-flex justify-content-between align-items-center">
            <li>
              <NavLink
                to="/"
                id="sidebarCollapse"
                data-toggle="sidebar"
                className="nav-link nav-link-lg">
                <i className="fas fa-bars"></i>
              </NavLink>
            </li>
            <li className="mx-auto">
              <NavLink
                to="/"
                data-toggle="search"
                className="nav-link nav-link-lg">
                <i className="fas fa-search"></i>
              </NavLink>
            </li>
          </ul>
          <div className="search-element">
            <input
              className="form-control"
              type="search"
              placeholder="Search"
              aria-label="Search"
              data-width="250"
            />
            <button className="btn" type="submit">
              <i className="fas fa-search"></i>
            </button>
          </div>
        </form>
        <ul className="navbar-nav navbar-right">
          <li className="nav-item d-flex align-items-center">
            {/* Auto-scrolling Notices - hide for Admin and Intern */}
            {type !== "Admin" && (
              //eslint-disable-next-line
              <marquee
                className="notice_marquee"
                style={{
                  width: "500px",
                  whiteSpace: "nowrap",
                  fontWeight: "bold",
                  color: "#fff",
                }}>
                {notices && notices.length > 0 ? (
                  notices.slice(0, 3).map((notice) => (
                    <span key={notice._id} style={{ marginRight: "50px" }}>
                      🔔 {notice.title} &mdash; {notice.content}
                    </span>
                  ))
                ) : (
                  <span>No notices available</span>
                )}
              </marquee>
            )}
          </li>

          {/* Notifications dropdown - hide for Admin and Intern */}
          {type !== "Admin" && (
            <li className="dropdown dropdown-list-toggle">
              <div
                data-toggle="dropdown"
                className="nav-link notification-toggle nav-link-lg"
                style={{ position: "relative" }}>
                <i className="far fa-bell"></i>
                {unreadCount > 0 && (
                  <span style={styles.notificationDot}></span>
                )}
              </div>

              <div className="dropdown-menu dropdown-list dropdown-menu-right">
                <div className="dropdown-header">
                  Notifications
                  <div className="float-right">
                    <button
                      className="btn btn-sm btn-link"
                      onClick={markAllAsRead}>
                      Mark All As Read
                    </button>
                  </div>
                </div>
                <div
                  className="dropdown-list-content dropdown-list-icons"
                  style={styles.scrollableDropdown}>
                  {isLoading ? (
                    <div className="dropdown-item text-center">Loading...</div>
                  ) : notices.length === 0 ? (
                    <div className="dropdown-item text-center">
                      No new notices
                    </div>
                  ) : (
                    notices.map((notice) => (
                      <NavLink
                        key={notice._id}
                        to="/notices"
                        className="dropdown-item"
                        style={notice.read ? {} : styles.unreadNotice}>
                        <div className="dropdown-item-icon bg-info text-white">
                          <i className="fas fa-bell"></i>
                        </div>
                        <div className="dropdown-item-desc">
                          <strong>{notice.title}</strong>
                          <br />
                          <span style={{ fontSize: "0.8rem", color: "#666" }}>
                            {notice.content}
                          </span>
                        </div>
                      </NavLink>
                    ))
                  )}
                </div>

                <div className="dropdown-footer text-center">
                  <NavLink to="/notices">
                    View All <i className="fas fa-chevron-right"></i>
                  </NavLink>
                </div>
              </div>
            </li>
          )}

          <li className="dropdown">
            <div
              data-toggle="dropdown"
              className="nav-link dropdown-toggle nav-link-lg nav-link-user">
              <img
                alt="profile"
                src={profile}
                className="rounded-circle mr-1"
              />
              <div className="d-sm-none d-lg-inline-block">Hi, {name}</div>
            </div>
            <div className="dropdown-menu dropdown-menu-right">
              <div className="dropdown-title">Logged in 5 min ago</div>
              <NavLink
                to={`/employee/${user.id}`}
                className="dropdown-item has-icon">
                <i className="far fa-user"></i> Profile
              </NavLink>
              <NavLink
                onClick={handleClick}
                to="features-activities.html"
                className="dropdown-item has-icon"
                style={{ cursor: "not-allowed" }}>
                <i className="fas fa-bolt"></i> Activities
              </NavLink>
              <NavLink
                onClick={handleClick}
                to="features-settings.html"
                className="dropdown-item has-icon"
                style={{ cursor: "not-allowed" }}>
                <i className="fas fa-cog"></i> Settings
              </NavLink>
              <div className="dropdown-divider"></div>
              <NavLink
                to="/"
                onClick={logout}
                className="dropdown-item has-icon text-danger">
                <i className="fas fa-sign-out-alt"></i> Logout
              </NavLink>
            </div>
          </li>
        </ul>
      </nav>
    </>
  );
};

export default Navigation;
